<template>
  <p id="head-title" class="head-title">
    {{ title }}
  </p>
</template>
<script>
export default {
  name: "HeadTitle",
  props: {
    title: String
  }
};
</script>
<style scoped>
.head-title {
  font-family: TiemposFont, Helvetica, Arial, sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  font-style: normal;
  color: #070e46;
  letter-spacing: 1px;
  margin: 0;
}
</style>
